import React from "react";
import classNames from "classnames";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableRow from "@material-ui/core/TableRow";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import Paper from "@material-ui/core/Paper";
import { withStyles } from "@material-ui/core/styles";
import EnhancedTableHead from "../../utils/EnhancedTableHead";
import { commonTablestyles } from "../../utils/Style";
import ReactTable from "react-table";
//import 'react-table/react-table.css'
import '../../css/react-table/react-table.css';
import { API_URL_DOMAIN2 } from "../constants";
import Navlink from "../../components/wrappers/Navlink";

const styles = (theme) => ({
  root: {
    flexGrow: 1,
  },
  loadingHeight: {
    height: "100%",
    position: "fixed",
    top: "0",
    right: "0",
  },
  container: {
    display: "flex",
    flexWrap: "wrap",
    width: 350,
  },
  button: {
    width: 300,
    marginLeft: "auto",
    marginRight: "auto",
    marginTop: 10,
  },
  alreadySignIn: {
    marginTop: 10,
    marginBottom: 10,
    marginLeft: "auto",
    marginRight: "auto",
  },
  success: {
    marginTop: 10,
    marginBottom: 10,
    marginLeft: "auto",

    marginRight: "auto",
    color: "green",
  },
});
class ReportListTable extends React.Component {
  submitClick = (value) => {};

  state = {
    open: false,
  };

  constructor(props, context) {
    super(props, context);
    this.state = {
      objects: [],
      selected: [],
      data: this.props.data,
      order: "asc",
      orderBy: "",
      page: 0,
    };
  }

  componentWillReceiveProps(nextProps) {
    this.setState({ selected: nextProps.selected });
    //this.setState({ page: nextProps.page });
    if (nextProps.data != this.state.data) {
      this.setState({ data: nextProps.data });
    }
  }

  isSelected = (id) => this.state.selected.indexOf(id) !== -1;

  renderReactTable(data, classes, columns) {
    return (
      <Paper>
        <Grid container className={classes.root}>
          <Grid item xs={12}>
            <Grid container justify="center" alignItems="center">
              Report List
            </Grid>
            <Grid container justify="center" alignItems="center">
              <ReactTable
                className="-striped -highlight"
                defaultPageSize={100}
                data={data}
                columns={columns}
                style={{ width: "98%" }}
              ></ReactTable>
            </Grid>
          </Grid>
        </Grid>
      </Paper>
    );
  }

  render() {
    const {
      classes,
      columnData,
      handleChangeRowsPerPage,
      handleModalOpen,
      handleChangePage,
      countuserValue,
      rowsPerPage,
      emptyRows,
      selected,
      handleClick,
      handleSelectAllClick,
      notify
    } = this.props;
    const { objects, order, orderBy, page, data } = this.state;
    const columns = [
      {
        Header: "ID",
        Cell: (props) => props.index + 1 ,
      },
      {
        Header: "Report Date",
        accessor: "report_date",
      },
      {
        Header: "UID",
        accessor: "encname",
      },
      {
        Header: "Fire Status",
        accessor: "fire_status",
      },
      {
        Header: "Parent",
        accessor: "company_group",
      },
      {
        Header: "Subsidiary",
        accessor: "member_name",
      },
      {
        Header: "Country",
        accessor: "country",
      },
      {
        Header: "Longitude",
        accessor: "longitude",
      },
      {
        Header: "Latitude",
        accessor: "latitude",
      },
      {
        Header: "Acq Date",
        accessor: "acqdate",
      },
      {
        Header: "Confidence",
        accessor: "confidence",
      },
      {
        Header: "Source",
        accessor: "source",
      },
      {
        Header: "Status",
        accessor: "status",
      },
      
      {
        Header: "Is Peat",
        accessor: "ispeat",
        Cell: (props) => (props.value ? "Yes" : "No"),
      },
      {
        Header: "Is Protected",
        accessor: "isprotected",
        Cell: (props) => (props.value ? "Yes" : "No"),
      },
      {
        Header: "Certified",
        accessor: "iscertified",
        Cell: (props) => (props.value ? "Yes" : "No"),
      },
      {
        Header: "Provence",
        accessor: "province",
      },

      {
        Header: "File paths",
        accessor: "filepaths",

        Cell: (props) =>
          props.value.length > 0
            ? props.value.map((x) => (
                <div>
                  <a href={x} target="_blank">
                    link here
                  </a>
                  <br />
                </div>
              ))
            : "",
      },
      {
        Header: "Consent",
        accessor: "consent",
        Cell: (props) =>
           
                <div> 
                  {props.value? "True": "False"}
                </div> 
      },
      {
        Header: "Action",
        minWidth: 300,
        Cell: (props) =>   (
           
          <div>
            <Button
              style={{ marginLeft: "10px" }}
              variant="contained"
              color="secondary"
              className={classes.button}
            >
              <Navlink
                style={{ color: "#fff" }}
                color="primary"
                variant="contained"
                to={
                  "//" +
                  API_URL_DOMAIN2 +
                  "/form?k=" +
                  localStorage.apiKey +
                  "&ses=" +
                  localStorage.sessionKey +
                  "&f=" +
                  props.row.encname
                }
                target="_blank"
              >
                <i className="fas fa-chart-line classes.heading" />
                View Report
              </Navlink>
            </Button>
            <Button
              style={{ marginLeft: "10px" }}
              variant="contained"
              color="secondary"
              disabled={props.row.status == 'Uploaded' }
              className={classes.button}
              onClick={e=> notify}
            >
               Send Notification
            </Button>{" "}
          </div>
        ),
      },
    ];

    return this.renderReactTable(data, classes, columns );
  }
}

export default withStyles(commonTablestyles)(ReportListTable);



// WEBPACK FOOTER //
// ./src/utils/MainTable/ReportListTable.js